import { render } from "./KariirekinSettingItem.vue?vue&type=template&id=fd23bdae&ts=true"
import script from "./KariirekinSettingItem.vue?vue&type=script&lang=ts"
export * from "./KariirekinSettingItem.vue?vue&type=script&lang=ts"

import "./KariirekinSettingItem.vue?vue&type=style&index=0&id=fd23bdae&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__